import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";import clsx from 'clsx';
import Button from "../Button";
import InputText from "../InputText";
import TableHeading from "../TableHeading";
import TableRow from "../TableRow";
import useFirstRender from "../../hooks/useFirstRender";
import React, { useEffect, useState } from 'react';

import colors from "../../utils/colors";
import { createStyles } from "./styles";

var TableHeaderWithInfo = function TableHeaderWithInfo(props) {
  var
    children =









    props.children,id = props.id,className = props.className,totalElements = props.totalElements,totalTitle = props.totalTitle,searchPlaceholder = props.searchPlaceholder,isSearchButtonDisabled = props.isSearchButtonDisabled,shouldValueBeCleared = props.shouldValueBeCleared,onSearch = props.onSearch,onReset = props.onReset;
  var classes = createStyles(props);

  var _useState = useState(''),_useState2 = _slicedToArray(_useState, 2),searchValue = _useState2[0],setSearchValue = _useState2[1];
  var firstRender = useFirstRender();

  useEffect(function () {
    if (!firstRender && !searchValue && onReset) {
      onReset();
    }
  }, [searchValue]);

  useEffect(function () {
    if (shouldValueBeCleared) {
      setSearchValue('');
    }
  }, [shouldValueBeCleared]);

  var updateSearchValue = function updateSearchValue(e) {
    setSearchValue(e.target.value);
  };

  return /*#__PURE__*/(
    React.createElement("thead", { className: clsx(classes.tableHead, className), id: id }, /*#__PURE__*/
    React.createElement(TableRow, null, /*#__PURE__*/
    React.createElement(TableHeading, { className: classes.headerInfoBlock }, /*#__PURE__*/
    React.createElement("div", { className: classes.searchBlock },
    onSearch && /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    React.createElement(InputText, {
      value: searchValue,
      onChange: updateSearchValue,
      placeholder: searchPlaceholder || 'Enter value',
      className: classes.searchInput }), /*#__PURE__*/

    React.createElement("div", { className: classes.searchButtons }, /*#__PURE__*/
    React.createElement(Button, {
      color: "primary",
      size: "large",
      className: classes.actionButton,
      disabled: isSearchButtonDisabled || false,
      onClick: function onClick() {
        onSearch(searchValue);
      } }, "Search"),



    onReset && searchValue && !isSearchButtonDisabled && /*#__PURE__*/
    React.createElement(Button, {
      color: "custom",
      customColor: colors.red[600],
      type: "outlined",
      size: "large",
      className: classes.actionButton,
      onClick: function onClick() {
        setSearchValue('');
        onReset();
      } }, "Reset")))),








    totalTitle && /*#__PURE__*/
    React.createElement("p", { className: classes.totalTitle },
    totalTitle, ":", /*#__PURE__*/React.createElement("b", { className: classes.totalElements }, totalElements || 0)))),




    children));


};

export default TableHeaderWithInfo;
//# sourceMappingURL=index.js.map